import { Directive, Input, inject } from '@angular/core';
import { BaseComponent, PlatformDeviceInfoToken } from '@ups/xplat/core';

@Directive()
export abstract class VersionDisplayBaseComponent extends BaseComponent {
  @Input() color = '#00275d';
  deviceInfo = inject(PlatformDeviceInfoToken);
}
